// extracted by mini-css-extract-plugin
export default {"toggleBox":"toggleBox_toggleBox__vP69M","itemList":"toggleBox_itemList__+6LXi"};